export interface RangeTimeType {
  fromDate: string
  toDate: string
}

export interface SimulationType {
  fromDate: string
  toDate?: string
  interfaceId: number
}

export interface HistoryType {
  fromDate?: string
  toDate?: string
  interfaceId: number
}

export interface TemplateWaterConsumptionType {
  interfaceId: number
  pipeIds: number[]
}

export interface WaterConsumptionType {
  fromDate: string
  toDate: string
  interfaceId: number
  pipeId: number
}

export interface WaterFlowSimulationRequest {
  fromDate: string
  toDate: string
  interfaceId: number
}

export interface WaterFlowStation {
  id: number
  description: string
  flow: number
  programId: number
  programName: string
  ts: number
}

export interface WaterFlowSimulationDataPoint {
  time: number
  totalWaterConsumed: number
  totalFlow: number
  stations: WaterFlowStation[]
}

export interface FormattedWaterFlowSimulationDataPoint extends WaterFlowSimulationDataPoint {
  timeISO: string
  timeFormatted: string
  timeDisplay: string
  isCurrentTime: boolean
  isPastTime: boolean
  isFutureTime: boolean
  minutesFromNow: number
  hoursFromNow: number
}

export enum LogTypeEnum {
  IoValue = 1,
  IoOn = 2,
  IoOff = 3,
  SystemStart = 4,
  CuStart = 5,
  EthernetLink = 6,
  EthernetIp = 7,
  Mqtt = 8,
  TwoWireStateChange = 9,
  TwLineVoltage = 10,
  TwLineLoad = 11,
  EngineStateChange = 12,
  WeEngineRain = 13,
  WeStationStateChange = 14,
  StationStart = 15,
  StationStop = 16,
  WeStationMad = 17,
  WeStationWp = 18,
  StationError = 19,
  FlowValveStateChange = 20,
  WeFlowValveOpen = 21,
  WeFlowValveClose = 22,
  FlowValveError = 23,
  FlowRuleStateChange = 24,
  FlowRuleError = 25,
  WeFlowRuleError = 25,
  WeRequestError = 26,
  TwoWireError = 27,
  WeEngineError = 28,
  LeActionError = 29,
  LeUserLog = 30,
  WeFlowSensorVolume = 31,
  RainVolume = 32,
  IOConfigExprInvalid = 33,
  ProgramStateChange = 34,
  ProgramNotCompleted = 35,
  ProgramStartTimeOverrun = 36,
  WeProgramWaterReferenceNotFound = 37,
  StationOverlappingProgram = 38,
  WeProgramStartTimeDuplicate = 39,
  WeFlowRuleFlow = 40,
  WeWaterReferenceValue = 41,
  CfgExpired = 42,
  WeProgramMoisture = 43,
  WifiStateChange = 44,
  HistoryET = 99,
  InterfaceStateChange = 100,
  WaterTankLevelChange = 110,
}

export interface StationSimulationEvent {
  time: string
  utcTime: string
  type: string
  typeId: LogTypeEnum
  id: number
  water_p?: string
  emitted_dl?: string
  runtime_sec?: string
  precipitation_dum?: string
  globalExpectedFlow_dl_min?: string
  expectedFlow_dl_min?: string
  programId?: number
  fromState?: string
  toState?: string
  ioAddr?: string
  ioIdx?: string
  errorCode?: string
}

export interface StationSimulationResponse {
  data: StationSimulationEvent[]
}

export interface FormattedStationSimulationEvent extends StationSimulationEvent {
  timeISO: string
  timeFormatted: string
  timeDisplay: string
  isCurrentTime: boolean
  isPastTime: boolean
  isFutureTime: boolean
  minutesFromNow: number
  hoursFromNow: number
  eventType: 'start' | 'stop' | 'program_change' | 'error'
  stationId: number
  utcTimeStart: string
}

export type WaterFlowSimulationResponse = StationSimulationEvent[]
export type FormattedWaterFlowSimulationResponse = FormattedStationSimulationEvent[]
